import dispatchRoutes from './routes'

/* @ngInject */
const dispatchRun = (
  $transitions,
  storageHandler,
  $$dispatch,
  toaster
) => {
  $transitions.onSuccess({
    entering: dispatchRoutes.home.path,
  }, (trans) => {
    if (storageHandler.get('consult.dispatch.myDispatch')) {
      $$dispatch.data.myDispatch = storageHandler.get('consult.dispatch.myDispatch')
    } else {
      $$dispatch.data.myDispatch = $$dispatch.new.search()
    }

    if (storageHandler.get('consult.dispatch.myDispatches')) {
      $$dispatch.data.myDispatches = storageHandler.get('consult.dispatch.myDispatches')
    } else {
      $$dispatch.data.myDispatches.splice(0, $$dispatch.data.myDispatches.length)
    }
  })

  $transitions.onBefore({
    from: dispatchRoutes.home.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('consult.dispatch.myDispatch', $$dispatch.data.myDispatch)
      storageHandler.save('consult.dispatch.myDispatches', $$dispatch.data.myDispatches)
      $$dispatch.data.myDispatch = null
      $$dispatch.data.myDispatches = null
    }
  })

  $transitions.onSuccess({
    entering: dispatchRoutes.new.path,
  }, (trans) => {
    if (storageHandler.get('consult.dispatch.new')) {
      $$dispatch.data.myDispatch = storageHandler.get('consult.dispatch.new')
    } else {
      $$dispatch.data.myDispatch = $$dispatch.new.classic()
    }
  })

  $transitions.onBefore({
    from: dispatchRoutes.new.path,
  }, (trans) => {
    if (!trans.to().redirectTo) {
      storageHandler.save('consult.dispatch.new', $$dispatch.data.myDispatch)
      $$dispatch.data.myDispatch = null
    }
  })

  $transitions.onSuccess({
    entering: dispatchRoutes.details.path,
  }, async (trans) => {
    const dispatchId = $$dispatch.local.getCurrentId()

    try {
      $$dispatch.data.myDispatch = await $$dispatch.request.getById(dispatchId)
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onBefore({
    exiting: dispatchRoutes.details.path,
  }, (trans) => {
    $$dispatch.data.myDispatch = null
  })

  $transitions.onSuccess({
    entering: dispatchRoutes.edit.path,
  }, async (trans) => {
    console.log('dispatch edit')
    const dispatchId = $$dispatch.local.getCurrentId()

    try {
      const dispatch = await $$dispatch.request.getById(dispatchId)
      $$dispatch.data.myDispatch = $$dispatch.format.user(dispatch)
    } catch (error) {
      toaster.error(error)
    }
  })

  $transitions.onBefore({
    exiting: dispatchRoutes.details.path,
  }, (trans) => {
    $$dispatch.data.myDispatch = null
  })
}

export default dispatchRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/dispatch/dispatch.run.js